import React, { Component } from "react";
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import axios from 'axios';
import { Button } from "@progress/kendo-react-buttons";
import GridLoading from '../Loaders/GridLoading';
import { process } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { parseDate } from '@telerik/kendo-intl';
import EntityPopup from "./components/EntityPopup";
// import CustomEntityPopup from "./components/CustomEntityPopup";

class BillingList extends Component {

  constructor(props) {
    super(props);

    this.minGridWidth = 0;



    var columns = [{ field: 'RunDate', title: 'Run Date', filter: 'text', format: '{0:d}', headerClass: 'gridHeader', width: 123 },
    { field: 'EntityCode', title: 'Entity Code', headerClass: 'gridHeader', width: 200 },
    { field: 'Name1', title: 'Name', headerClass: 'gridHeader', minWidth: 150 },
    { field: 'BillType', title: 'Bill Type', headerClass: 'gridHeader', width: 120 },
    { field: 'PerfClassificationType', title: 'Bill Classification', headerClass: 'gridHeader', width: 150 },
    { field: 'PerfClassificationCode', title: 'Bill Classification Code', headerClass: 'gridHeader', width: 183 },
    { field: 'AverageCost', title: 'Average Cost', headerClass: 'gridHeader', width: 115 },
    { field: 'Prorated', title: 'Pro Rated', headerClass: 'gridHeader', width: 92 },
    // { field: 'edit', headerClass: 'gridHeader', filterable: false, title: ' ', cell: (p) => this.createCell(p), width: 85 },
    ]


    this.state = {
      users: [],
      roles: [],
      result: [],
      refreshText: '',
      filterable: true,
      groups: false,
      logs: false,
      columns: columns,
      dataState: { skip: 0, take: 25, sort: [{ field: 'RunDate', dir: 'asc' }, { field: 'EntityCode', dir: 'asc' }] },
      fileDownload: [],
      billing: [],
      demographicsExport: [],
      exportColumns: [],
      demographicsCustomExport: [],
      exportColumnsCustom: [],
      // advAllUsers: false
    }

    // this.createCell = this.createCell.bind(this);
    this.getBilling = this.getBilling.bind(this);
    this.getDate = this.getDate.bind(this);
    this.getSuperAdminSettings = this.getSuperAdminSettings.bind(this);

  }

  componentDidMount() {
    this.getSuperAdminSettings();
    this.getStyleSettings()
    this.getBilling()
  }

  componentDidUpdate() {

  }

  getStyleSettings = (cb) => {
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var styleNames = ['requireTermsAndConditions,RIAFirmName,showFilters']

    axios(`api/getStyleSettings`, {
      method: 'GET',
      params: { company: this.props.user.company, styleNames: styleNames },
      headers: headers
    })
      .then(response => {
        this.setState((prevState) => {
          let obj = {
            ...prevState,
            requireTermsAndConditions: response.data.styleSettings.requireTermsAndConditions,
            filterable: response.data.styleSettings.showFilters,
            RIAFirmName: response.data.styleSettings.RIAFirmName
          };
          return obj;
        }, () => { if (cb) cb() })
      })
      .catch(err => {
        console.error(err);
        if (cb) cb()
      })
  }

  getSuperAdminSettings() {
    const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    axios(`api/superAdminSettings`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers
    })
      .then(response => {
        response.data.data.forEach(setting => {
          if (setting.settingName === 'enableMFA') {
            this.setState({ enableMFA: setting.settingValue.toLowerCase() === 'true' ? true : false })
          }
        })

      })
      .catch(err => console.log(err));
  }


  getBilling(cb) {
    this.setState({ refreshText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var billing = [];



    axios(`api/billingList`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        console.log(response)
        billing = this.formatBillingList(response.data.data);
        var result = process(billing, this.state.dataState)
        this.setState({ billing: billing, result: result, refreshText: '' })

      })
      .catch(err => {
        console.error(err);
      })
  }

  formatBillingList(billingList) {
    for (let i = 0; i < billingList.length; i++) {

      billingList[i].RunDate = billingList[i].RunDate ? this.formatDate(billingList[i].RunDate) : null;

    }

    return billingList;
  }

  formatDate(date) {
    var d;

    if (parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX")) { d = parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX") }
    else { d = parseDate(date, "MM/dd/yyyy HH:mm:ss") }

    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = d.getUTCFullYear();

    return `${month}/${day}/${year}`;

  }

  getDate(sqlDate) {
    var d = parseDate(sqlDate, "yyyy-MM-ddTHH:mm:ss.SSSXXX");
    var utc = null;

    if (d !== null)
      utc = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());

    return utc;
  }

  createCell(cell) {
    return (
      <td>
        {/* <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getBilling} entity={cell.dataItem.EntityCode} button={<Button>Edit</Button>} /> */}
        <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getBilling} dataRow={cell.dataItem} button={<Button icon="edit" title='Edit'>Edit</Button>} />
      </td>
    );
  }

  expandChange = (event) => {
    const data = this.state.result.data.map(item =>
      item.id === event.dataItem.id
        ? {
          ...item,
          expanded: !item.expanded,
          enableMFA: this.state.enableMFA,
          templates: this.state.templates,
          tempDefault: this.state.tempDefault
        }
        : item
    );
    this.setState((prevState) => {
      let obj = { ...prevState };
      obj.result.data = data;
      return obj;
    })
  };

  _export;

  export = () => {
    this.setState({ exportLoadingText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };



    axios(`api/billingAll`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        // var folder
        var exportColumns = []
        var format = ''
        var key = null
        for (let j = 0; j < Object.keys(response.data.data[0]).length; j++) {
          key = Object.keys(response.data.data[0])[j]
          if (key.toLowerCase() !== 'date') { exportColumns.push({ field: key, format: format }) }
        }

        this.setState({ billingExport: this.getFullFilteredList(response.data.data), exportColumns: exportColumns }, () => {
          this._export.save();
        })
      })
      .catch(err => {
        console.error(err);
      })

  }

  getFullFilteredList(list) {//for excel export, otherwise only the amount of users on a single page would be exported
    let noSkipDataState = { ...this.state.dataState }

    noSkipDataState.skip = null
    noSkipDataState.take = null

    return process(list, noSkipDataState).data;
    //return process(this.state.users, noSkipDataState);
  }

  changeDataState = (e) => {
    var data = { ...e.dataState }
    if (data.filter != null && data.filter.filters != null) {
      data.filter.filters.forEach(item => {
      })
      // data.filter.filters = data.filter.filters.filter(item => item.value !== '(All)');
    }
    var newData = process(this.state.billing, data);
    this.setState({ dataState: data, result: newData });
  }

  selectionChange(event, gFiles) {
    event.dataItem.selected = !event.dataItem.selected;
    var selectedFiles = [];
    for (let i = 0; i < gFiles.length; i++) {
      if (gFiles[i].selected) {
        selectedFiles.push(gFiles[i]);
      }
    }
    this.setState({ fileDownload: selectedFiles });
    if (selectedFiles.length > 0) {
      this.setState({ fileSelected: true });
    }
    else {
      this.setState({ fileSelected: false });
    }
    this.forceUpdate();
  }

  headerSelectionChange(event, gFiles) {
    const checked = event.syntheticEvent.target.checked;
    gFiles.forEach(item => item.selected = checked);
    var selectedFiles = [];
    for (let i = 0; i < gFiles.length; i++) {
      if (gFiles[i].selected) {
        selectedFiles.push(gFiles[i]);
      }
    }
    this.setState({ fileDownload: selectedFiles });
    console.log(selectedFiles)
    if (selectedFiles.length > 0) {
      this.setState({ fileSelected: true });
    }
    else {
      this.setState({ fileSelected: false });
    }
    this.forceUpdate();
  }

  onDelete() {
    console.log(this.state.fileDownload)
    if (window.confirm('Are you sure you want to delete ' + this.state.fileDownload.length + ' rows? This cannot be undone')) {
      this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var payload = {
        company: this.props.user.company,
        rows: this.state.fileDownload
      };

      axios.post('api/billingEntityDelete', payload, { headers }).then(response => {
        console.log(response)
        this.setState({ fileDownload: [] })
        this.getBilling();

      })
        .catch(err => {
          console.error(err);
        })
    }
  }

  render() {
    return (
      <div>
        {!this.state.groups && !this.state.logs && (
          <div className="billingList">
            <ExcelExport data={this.state.billingExport} onExportComplete={() => { this.setState({ exportLoadingText: '' }) }} fileName='Billing_Export.xlsx' ref={(exporter) => { this._export = exporter; }}>
              {this.state.exportColumns.map((column, key) => {
                return <ExcelExportColumn field={column.field} cellOptions={{ format: column.format }} title={column.field} key={key} />
              })}
            </ExcelExport>
            <Grid data={this.state.result}
              selectedField='selected'
              resizable={true}
              reorderable={true}
              pageable={{ pageSizes: [10, 25, 50, 100, 250, 500] }}
              sortable={{ mode: 'multiple' }}
              onSelectionChange={(e) => this.selectionChange(e, this.state.billing)}
              onRowClick={(e) => this.selectionChange(e, this.state.billing)}
              onHeaderSelectionChange={(e) => this.headerSelectionChange(e, this.state.billing)}
              onDataStateChange={this.changeDataState}
              filterable={this.state.filterable}
              {...this.state.dataState}>
              <GridNoRecords>
                {this.state.refreshText && ''}
                {!this.state.refreshText && 'No records available'}
              </GridNoRecords>
              <GridToolbar>
                <Button icon='refresh' title='Refresh' onClick={(e) => this.getBilling()}>{this.state.refreshText}</Button>
                {/* <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getBilling} create={true} entity={''} button={<Button icon="plus" title='New'>New</Button>} /> */}
                <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getBilling} create={true} button={<Button icon="plus" title='New'>Add Entry</Button>} />
                <Button icon="upload" title='Import' onClick={() => { }}>Import</Button>
                <Button icon="excel" title='Export to Excel' disabled={this.state.exportLoadingText} onClick={this.export}>{this.state.exportLoadingText || 'Export'}</Button>
                {/* <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getBilling} dataRow={this.state.fileDownload.length === 1 ? this.state.fileDownload[0] : ''} button={<Button disabled={this.state.fileDownload.length !== 1} icon="edit" title='Edit'>Edit</Button>} /> */}
                <Button icon="delete" title='Delete' disabled={this.state.fileDownload.length <= 0} onClick={() => { this.onDelete() }}>{'Delete Billing Row(s)'}</Button>
              </GridToolbar>
              <GridColumn width='50px' field="selected" filterable={false} headerClassName='gridHeader' headerSelectionValue={this.state.billing.findIndex(dataItem => dataItem.selected === false) === -1} />
              {
                this.state.columns.map((column, key) => {
                  return <GridColumn field={column.field} title={column.title} key={key} format={column.format} cell={column.cell} filterable={column.filterable} filterCell={column.filterCell} filter={column.filter} headerClassName={column.headerClass} width={column.width} />
                })
              }
              <GridColumn
                field='edit' 
                headerClass='gridHeader' 
                filterable={false}
                title=" "
                width="85px"
                cells={{
                  data: (props) => this.createCell(props)
                }}
              />
            </Grid>
            {this.state.refreshText && <GridLoading gridClass='userList' />}
          </div>)
        }
      </div>
    );
  }

}

export default BillingList;